import React from 'react';
import { Navigate } from 'react-router-dom';
import ForgotPasswordForm from '../components/auth/forgot-password-form';
import { useAuth } from '../hooks/use-auth';

const ForgotPassword: React.FC = () => {
  const { session } = useAuth();

  // If already authenticated, redirect to home page
  if (session) {
    return <Navigate to="/" />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img
          className="mx-auto h-24 w-auto"
          src="/logo.png"
          alt="KAIMED - Patient First. Every Test Connected."
        />
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Reset your password
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <ForgotPasswordForm />
      </div>
    </div>
  );
};

export default ForgotPassword; 